









import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class SearchBoxPlaceholder extends Vue {
  @Prop({ required: true })
  inputQuery: string;

  @Prop({ required: true })
  opened: boolean;

  @Prop({ default: true })
  loopable: boolean;

  @Prop({ default: 50 })
  typingStepDurationInMs: number;

  @Prop({ default: 30 })
  deletingStepDurationInMs: number;

  @Prop({ default: 350 })
  delayDurationBetweenActionsInMs: number;

  currentPlaceholder = '';
  currentCharIndex: number;

  currentAlternative: string;
  currentAlternativeIndex: number;

  charsNumberDiffDelete: number;
  lastTimeout: number;

  get placeholderAlternatives() {
    return this.$x.messages.search.inputPlaceholderAlternativesHTML;
  }

  @Watch('inputQuery', { immediate: true })
  @Watch('opened', { immediate: true })
  private resetPlaceholder() {
    this.clearLastTimeout();
    if (!this.inputQuery && this.opened && this.placeholderAlternatives.length > 0) {
      this.currentPlaceholder = this.placeholderAlternatives[0];
      this.currentCharIndex = this.placeholderAlternatives[0].length - 1;
      this.currentAlternativeIndex = 0;
      this.currentAlternative = this.placeholderAlternatives[this.currentAlternativeIndex];
      this.checkNextAlternative();
    }
  }

  private checkNextAlternative() {
    this.currentAlternativeIndex++;
    if (this.currentAlternativeIndex < this.placeholderAlternatives.length) {
      this.checkEmptyPlaceholder();
    } else if (this.loopable) {
      this.resetAlternativesLoop();
    }
  }

  private resetAlternativesLoop() {
    let currentAlternativeIndexAux = 0;
    while (this.placeholderAlternatives[currentAlternativeIndexAux].length === 0) {
      currentAlternativeIndexAux++;
    }
    this.currentAlternativeIndex = currentAlternativeIndexAux;
    this.checkEmptyPlaceholder();
  }

  private checkEmptyPlaceholder() {
    if (this.currentAlternative.length === 0) { // Avoid deleting with an empty string
      this.initNextAlternative();
    } else {
      this.calculateCharactersToDelete();
    }
  }

  private initNextAlternative() {
    this.currentAlternative = this.placeholderAlternatives[this.currentAlternativeIndex];
    this.typing();
  }

  private typing() {
    // Avoid typing with an empty string and the placeholder displayed is already the same (it comes from deleting - composition strings)
    if (this.currentAlternative.length > 0 && this.currentCharIndex !== this.currentAlternative.length) {
      this.currentPlaceholder += this.currentAlternative.charAt(this.currentCharIndex);
      this.currentCharIndex++;
    }

    if (this.currentCharIndex < this.currentAlternative.length) {
      this.storeLastTimeout(this.typing, this.typingStepDurationInMs);
    } else {
      this.checkNextAlternative();
    }
  }

  private calculateCharactersToDelete() {
    const nextAlternative = this.placeholderAlternatives[this.currentAlternativeIndex];
    for (let i = 0; i < this.currentAlternative.length; i++) {
      if (this.currentAlternative.charAt(i) !== nextAlternative.charAt(i)) {
        this.charsNumberDiffDelete = this.currentAlternative.length - i;
        this.storeLastTimeout(this.deleting, this.delayDurationBetweenActionsInMs);
        return;
      }
    }
    this.initNextAlternative(); // When it is not necessary to delete characters (composition of strings)
  }

  private deleting() {
    this.currentCharIndex--;
    this.charsNumberDiffDelete--;
    this.currentPlaceholder = this.currentPlaceholder.slice(0, -1);

    if (this.charsNumberDiffDelete !== 0) {
      this.storeLastTimeout(this.deleting, this.deletingStepDurationInMs);
    } else {
      this.initNextAlternative();
    }
  }

  private storeLastTimeout(operation: () => void, timeout: number) {
    // window.setTimeout just for number type
    this.lastTimeout = window.setTimeout(operation, timeout);
  }

  private clearLastTimeout() {
    clearTimeout(this.lastTimeout);
  }
}
